import router from '@/router'
import { Route } from 'vue-router'
import { useUserStore } from '@/stores/user'
import { getSubdomain } from '@/utils/subdomain-handler'

const whiteList: string[] = [
  '/login',
  '/sign-up',
  '/forgot-password',
  '/reset-password',
  '/send-magic-link',
  '/send-magic-link?invalid=true',
  '/unconfirmed-email',
  '/confirmed-email',
  '/opt-in-refused',
  '/token-expired',
  '/lyfpay-transition',
  '/cgv',
  '/privacy'
]

router.beforeEach(async (to: Route, _: Route, next: any) => {
  const userStore = useUserStore()
  let nextRoute = to.path === '/login' ? undefined : to.query.redirect

  const authorizationCode = to.query.code
  const lyfToken = to.query.jwt?.toString()
  const signInWithLyf = lyfToken !== undefined && lyfToken !== userStore.externalToken
  const pcsToken = to.query.pcs_jwt?.toString()
  const signInWithPcs = pcsToken !== undefined && pcsToken !== userStore.externalToken
  const emrysToken = to.query.e_jwt?.toString()
  const signInWithEmrys = emrysToken !== undefined && emrysToken !== userStore.externalToken
  const vegaceToken = to.query.v_jwt?.toString()
  const signInWithVegace = vegaceToken !== undefined && vegaceToken !== userStore.externalToken

  const autoSignInRedirect = to.query.sign_in_redirect === 'true'

  let replace = false

  if (authorizationCode) {
    await userStore.signinRedirectCallback()

    nextRoute = (nextRoute || to.path).toString()
    replace = true
  } else if (signInWithLyf) {
    await userStore.loginWithLyfpay(lyfToken)
    if (userStore.optInRefused) nextRoute = '/opt-in-refused'
    else if (userStore.displayWalleoOnboarding || userStore.lyfpayNoAccount) nextRoute = '/lyfpay-transition'
  } else if (signInWithPcs) {
    await userStore.loginWithPcs(pcsToken)
  } else if (signInWithEmrys) {
    await userStore.loginWithEmrys(emrysToken)
  } else if (signInWithVegace) {
    await userStore.loginWithVegace(vegaceToken)
  } else if (autoSignInRedirect) {
    await userStore.signinRedirect()
  }

  await userStore.getUser()

  if (userStore.user || userStore.token) {
    if (to.path !== '/login' && to.path !== '/sign-up' && !userStore.model.isPersisted) {
      try {
        await userStore.getModelUser()
      } catch (err) {
        userStore.resetToken()

        nextRoute = `/login?redirect=${encodeURIComponent(to.fullPath)}`
        if (to.query.lyf) nextRoute += `&lyf=true`
      }
    }
  } else {
    const toPath = (nextRoute || to.path).toString()
    if (whiteList.indexOf(toPath) === -1) {
      nextRoute = `/login?sign_in_redirect=true&redirect=${encodeURIComponent(to.fullPath)}`
      if (to.query.lyf) nextRoute += `&lyf=true`
    }
  }

  const defaultHome = (
    userStore.isDualFlowEnabled
    || userStore.isVegaCECustomer
    || getSubdomain() === 'vegace'
  ) ? '/search' : '/home'

  if ((to.path === '/login' || to.path === '/sign-up') && (userStore.user || userStore.token)) {
    if (!userStore.model.isPersisted) {
      try {
        await userStore.getModelUser()
      } catch (err) {
        userStore.resetToken()
      }
    }
    nextRoute = (
      userStore.isDualFlowEnabled
      || userStore.isVegaCECustomer
      || getSubdomain() === 'vegace'
    ) ? '/search' : '/home'
  }

  const verification_status = ['waiting', 'verification_failed']
  if (verification_status.includes(userStore.model.registrationStatus) && to.path !== '/verification') nextRoute = '/verification'
  else if (!verification_status.includes(userStore.model.registrationStatus) && to.path == '/verification') nextRoute = defaultHome

  if (userStore.model.locked && to.path !== '/locked' && to.path !== '/sav') nextRoute = '/locked'
  else if (!userStore.model.locked && to.path === '/locked') nextRoute = defaultHome

  next({ path: nextRoute, replace: replace })
})
